var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var ink = {
    inkHeadline: "#640038",
    inkStrong: "#464647",
    inkBase: "#5C5757",
    inkSubtle: "#A0A09B",
    inkNonEssential: "#D9D9D7",
};
var primary = {
    primary120: "#900860",
    primary110: "#CC0E6E",
    primary100: "#E30E76",
    primary90: "#F43E8E",
    primary80: "#F186BA",
    primary70: "#F49DC8",
    primary60: "#F7B7D6",
    primary50: "#F9CEE4",
    primary40: "#FBE7F0",
};
var neutral = {
    neutral50: "#A0A09A",
    neutral40: "#D9D9D7",
    neutral30: "#E3E3E1",
    neutral20: "#F5F5F5",
    neutral10: "#FBFBFB",
    neutral5: "#FAFAFE",
};
var green = {
    green100: "#01EC9D",
    green50: "#80F6CD",
    green40: "#99F8D7",
    green30: "#B0F9E0",
    green20: "#CAF8E8",
    green10: "#E5FCF4",
};
var blue = {
    blue100: "#00C0F3",
    blue50: "#7FDCF5",
    blue40: "#94DDF1",
    blue30: "#B2ECFB",
    blue20: "#CAEFF9",
    blue10: "#E3F7FC",
};
var purple = {
    purple100: "#956AFF",
    purple50: "#C7B4FD",
    purple40: "#D2C2FD",
    purple30: "#DFD3FF",
    purple20: "#EAE1FF",
    purple10: "#F4F0FF",
};
var yellow = {
    yellow100: "#FED702",
    yellow50: "#FFEB80",
    yellow40: "#FFEF99",
    yellow30: "#FFF3B2",
    yellow20: "#FFF7CB",
    yellow10: "#FFFBE5",
};
var status = {
    error100: "#FF5F5F",
    error10: "#FFF2F2",
    warning100: "#F19E22",
    warning10: "#FFF7E6",
    success100: "#66CC78",
    success10: "#EBF9EE",
    info100: "#5989D8",
    info10: "#E6EDF9",
};
var metallic = {
    metallic50: "#87879F",
    metallic40: "#AAAABF",
    metallic30: "#B9B9CC",
    metallic20: "#DEDEEF",
    metallic10: "#EFF0FA",
};
var quality = {
    common50: "#35CB95",
    common10: "#EFFBF7",
    rare50: "#569DE9",
    rare10: "#F1F7FD",
    epic50: "#956AFF",
    epic10: "#F7F3FF",
};
export var foundation = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ ink: ink, primary: primary, neutral: neutral, green: green, blue: blue, purple: purple, yellow: yellow, status: status, metallic: metallic, quality: quality }, ink), primary), neutral), green), blue), purple), yellow), status), metallic), quality);
